import './facebook.css'
import { signInWithPopup, FacebookAuthProvider } from "firebase/auth";
import {auth} from '../config/firebase'
import {BsFacebook} from 'react-icons/bs'


const FbLogin=()=>{

    const Fbpvdr=()=>{   
  const provider = new FacebookAuthProvider();
  
signInWithPopup(auth, provider)
  .then((result) => {

    const user = result.user;
    console.log(user);
    const credential = FacebookAuthProvider.credentialFromResult(result);
    const accessToken = credential.accessToken;

    // ...
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = FacebookAuthProvider.credentialFromError(error);

    // ...
  });
    }
    return(
    
            // <button >
        <div className="cont" onClick={Fbpvdr}>
          <BsFacebook style={{width:'10%',height:'22px',color:'rgb(24,119, 242)'}} />
             
             <p className='cont-text'>Continue with Facebook</p>
        </div>
            // </button>
    )
}
export default FbLogin;